import api from 'connections/api';
import routes_api from 'connections/routes_api';
import {
  applyCardReorder,
  applyColumnReorder,
  deleteCardCache,
  deleteColumnCache,
  deleteProjectCache,
  upsertPlannerRecord,
} from 'offline_items/plannerProjectsOffline';

function cameFromCache(res) {
  return Boolean(res?.fromCache);
}

export async function listProjects() {
  const res = await api.get(routes_api.planner_projects);
  const data = res.data;
  if (!cameFromCache(res)) return data;
  const rows = Array.isArray(data) ? data : data?.results || [];
  return [...rows].sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0));
}

export async function createProject(payload) {
  const res = await api.post(routes_api.planner_projects, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_projects', res.data);
  return res.data;
}

export async function updateProject(id, payload) {
  const res = await api.patch(`${routes_api.planner_projects}${id}/`, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_projects', res.data);
  return res.data;
}

export async function deleteProject(id) {
  const res = await api.delete(`${routes_api.planner_projects}${id}/`);
  if (!cameFromCache(res)) await deleteProjectCache(id);
}

export async function fetchBoard(projectId) {
  const res = await api.get(`${routes_api.planner_projects}${projectId}/board/`);
  return res.data;
}

export async function listColumns(projectId) {
  const res = await api.get(routes_api.planner_project_columns, {
    params: { project: projectId },
  });
  return res.data;
}

export async function createColumn(payload) {
  const res = await api.post(routes_api.planner_project_columns, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_project_columns', res.data);
  return res.data;
}

export async function updateColumn(id, payload) {
  const res = await api.patch(`${routes_api.planner_project_columns}${id}/`, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_project_columns', res.data);
  return res.data;
}

export async function deleteColumn(id, deleteCards = false) {
  const res = await api.delete(`${routes_api.planner_project_columns}${id}/`, {
    params: deleteCards ? { delete_cards: 'true' } : {},
  });
  if (!cameFromCache(res)) await deleteColumnCache(id, { purgeCards: deleteCards });
}

export async function reorderColumns(projectId, columns) {
  const res = await api.post(`${routes_api.planner_project_columns}reorder_columns/`, {
    project_id: projectId,
    columns,
  });
  if (!cameFromCache(res)) await applyColumnReorder(columns, { synced: true });
}

export async function createCard(payload) {
  const res = await api.post(routes_api.planner_project_cards, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_project_cards', res.data);
  return res.data;
}

export async function updateCard(id, payload) {
  const res = await api.patch(`${routes_api.planner_project_cards}${id}/`, payload);
  if (!cameFromCache(res)) await upsertPlannerRecord('planner_project_cards', res.data);
  return res.data;
}

export async function deleteCard(id) {
  const res = await api.delete(`${routes_api.planner_project_cards}${id}/`);
  if (!cameFromCache(res)) await deleteCardCache(id);
}

export async function reorderCards(projectId, updates) {
  const res = await api.post(`${routes_api.planner_project_cards}reorder_cards/`, {
    project_id: projectId,
    updates,
  });
  if (!cameFromCache(res)) await applyCardReorder(updates, { synced: true });
}
